import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/auth/Login';
// components
import LoadingScreen from '../components/LoadingScreen';
import { checkAcceptRules } from 'src/utils/rules';
import RulesPage from 'src/pages/rules';
import { detectFirefox } from 'src/utils';
import FireFoxModal from 'src/components/fireFox';
import CompeletePageLottery from 'src/pages/compeltePage';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children, isPublic }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const admin = useSelector((store) => store.admin);
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (admin.isLoading) {
    return <LoadingScreen />;
  }

  // if (!isAuthenticated && !checkAcceptRules() && pathname !== "/rules") {
  if (!checkAcceptRules() && pathname !== "/rules") {
    return <Navigate to={"/rules"} />;
    // return <RulesPage />;
  }

  if (isAuthenticated && (admin?.data?.has_won_lottery === 3 || admin?.data?.has_won_lottery === "3") && pathname !== "/wait") {
    return <Navigate to={"/wait"} />;
    // return <RulesPage />;
  }

  // if(true){
  //   return <CompeletePageLottery />
  // }

  if (!isAuthenticated && !isPublic) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  if (detectFirefox()) {
    return (
      <>
        <FireFoxModal />
        {children}
      </>
    )
  }

  return <>{children}</>;
}
